import * as React from "react";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text";

interface CreditRowHeadersRightProps {
  showApprovalColumn: boolean;
}
export const CreditRowHeadersRight: React.ReactFCWithChildren<CreditRowHeadersRightProps> = ({ showApprovalColumn }) => {
  return (
    <Grid.Bounds className="row-right row-right-heading">
      <div className="credit-col heading-col requested-quantity-col">
        <Text weight="bold">
          Claim QTY
        </Text>
      </div>

      <div className="credit-col heading-col reason-col">
        <Text weight="bold">
          Reason
        </Text>
      </div>

      {showApprovalColumn && (
        <div className="credit-col heading-col approved-quantity-col">
          <Text weight="bold">
            Approved
          </Text>
        </div>
      )}
    </Grid.Bounds>
  );
};
